export default "__VITE_ASSET__CPAzxGb___"